import { FC } from 'react';
import { Button, Divider, Stack, Text } from '@chakra-ui/react';
import { useTransactions } from 'store/transactions/useTransactions';
import { ExtendedRewardProgram, TemplateName } from 'types';
import { PowerSwitchStatus } from 'api/blockchain/rewardProgram';
import { mapTemplateNameToPowerswitchAbi } from 'utils/aludelMappings';

type Props = {
  program: ExtendedRewardProgram;
  programState?: PowerSwitchStatus;
};

export const AludelStatusForm: FC<Props> = ({ program, programState }) => {
  const { updateAludelStatus } = useTransactions();

  const powerSwitchAbi =
    mapTemplateNameToPowerswitchAbi[
      program.rewardProgram.templateName as TemplateName
    ];

  const handleAludelStatusChange = async (
    action: 'powerOn' | 'powerOff' | 'emergencyShutdown'
  ) => {
    await updateAludelStatus(
      program.rewardProgramAddress,
      program.rewardProgram.powerSwitchAddress,
      action,
      powerSwitchAbi
    );
  };

  return (
    <>
      <Stack spacing={8} divider={<Divider />}>
        {programState !== PowerSwitchStatus.SHUTDOWN ? (
          <>
            <Stack>
              <Text color='gray.200' mb={2}>
                {programState === PowerSwitchStatus.ONLINE ||
                programState === PowerSwitchStatus.NOTSTARTED
                  ? 'This option allows you temporarily power off the reward program, preventing users from entering and leaving. This also reduces visibility for the program on the website. Users currently subscribed can "Emergency Exit" the program while it is powered off.'
                  : 'The program is currently offline, this means users currently cannot join or leave in a normal way. You can use this option to switch the reward program back online.'}
              </Text>
              <Button
                width='fit-content'
                type='submit'
                borderRadius={'lg'}
                onClick={() =>
                  programState === PowerSwitchStatus.ONLINE ||
                  programState === PowerSwitchStatus.NOTSTARTED
                    ? handleAludelStatusChange('powerOff')
                    : handleAludelStatusChange('powerOn')
                }
              >
                {programState === PowerSwitchStatus.ONLINE ||
                programState === PowerSwitchStatus.NOTSTARTED
                  ? 'Power off Aludel'
                  : 'Power on Aludel'}
              </Button>
            </Stack>
          </>
        ) : (
          ''
        )}
        <Stack>
          {programState === PowerSwitchStatus.SHUTDOWN ? (
            <>
              <Text color='gray.200' mb={5}>
                <strong>This program has been permanently shutdown.</strong>
              </Text>
              <Text color='gray.200' mb={5}>
                You can no longer power this program back online. Users can only
                exit via "Emergency Exit". Funds in the pool can now be
                withdrawn by the Power Switch owner using the Rescue Funds
                option.
              </Text>
            </>
          ) : (
            <>
              <Text color='gray.200' mb={5}>
                This option will permanently shutdown the reward program,
                preventing users from joining or leaving in a normal way.
              </Text>
              <Text color='gray.200' mb={5}>
                This also delists the program however the program will still be
                searchable or visible to current participants.
              </Text>
              <Text color='gray.200' mb={5}>
                When the program is shutdown, users can only leave via
                "Emergency Exit". Funds within the reward program can be
                withdrawn after the program has been shutdown.
              </Text>
              <Button
                width='fit-content'
                type='submit'
                borderRadius={'lg'}
                onClick={() => handleAludelStatusChange('emergencyShutdown')}
              >
                Shutdown Aludel
              </Button>
            </>
          )}
        </Stack>
      </Stack>
    </>
  );
};
